
import React from 'react';
import { Input } from '../../../../../components/ui/input';
import { BaseFieldPreviewProps } from './previewUtils';

const DateFieldPreview: React.FC<BaseFieldPreviewProps> = ({ field, renderDescription }) => {
  return (
    <div>
      {renderDescription()}
      <Input type="date" disabled className="bg-white" />
    </div>
  );
};

export default DateFieldPreview;
